import { Result } from '@/reservation/reservation.model';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Layout } from './connect-bus-layouts.component';

@Injectable()
export class ConnectBusLayoutsApiService {
	private readonly apiUrl = environment.apiUrl;

	private readonly httpClient = inject(HttpClient);

	getTransportLayout(params = ''): Observable<Result<Layout>> {
		return this.httpClient.get<Result<Layout>>(`${this.apiUrl}/transport/layout/?${params}`);
	}

	getTransportLayoutById(id: number): Observable<Layout> {
		return this.httpClient.get<Layout>(`${this.apiUrl}/transport/layout/${id}/`);
	}

	putTransportLayout(layout: Layout): Observable<unknown> {
		return this.httpClient.put<unknown>(`${this.apiUrl}/transport/layout/${layout.id}/`, layout);
	}
}
